import Big from 'big.js';

import { CardProduct } from 'app/model/product/CardProduct';
import { InsuranceProduct } from 'app/model/product/InsuranceProduct';

export class RkkCardProduct extends CardProduct {
    /**
     * Ставка по рассрочке
     */
    installmentRate: Big;

    /**
     * Срок рассрочки (месяцы)
     */
    installmentTerm: number;

    /**
     * Сумма комиссии за обслуживание карты
     */
    commissionAmount: Big;

    constructor(
        id: string,
        code: string,
        name: string,
        minAmount: Big,
        maxAmount: Big,
        soleTradersMaxAmount: Big,
        selfEmployedMaxAmount: Big,
        currency: string,
        rate: Big,
        grantTerm: number,
        paymentTerm: number,
        insurance: Array<InsuranceProduct>,
        insuranceRequired: boolean,
        insuranceEnabled: boolean,
        installmentRate: Big,
        installmentTerm: number,
        commissionAmount: Big,
        minInterestRate: Big,
    ) {
        super(
            id,
            code,
            name,
            minAmount,
            maxAmount,
            soleTradersMaxAmount,
            selfEmployedMaxAmount,
            currency,
            rate,
            grantTerm,
            paymentTerm,
            insurance,
            insuranceRequired,
            insuranceEnabled,
            minInterestRate,
        );
        this.installmentRate = installmentRate;
        this.installmentTerm = installmentTerm;
        this.commissionAmount = commissionAmount;
    }

    static deserialize(data: any) {
        return new RkkCardProduct(
            data.id,
            data.code,
            data.name,
            new Big(data.minAmount),
            new Big(data.maxAmount),
            new Big(data.soleTradersMaxAmount),
            new Big(data.selfEmployedMaxAmount),
            data.currency,
            new Big(data.rate),
            data.grantTerm,
            data.paymentTerm,
            data.insurance.map(InsuranceProduct.deserialize),
            data.insuranceRequired,
            data.insuranceEnabled,
            new Big(data.installmentRate),
            data.installmentTerm,
            new Big(data.commissionAmount),
            new Big(data.minInterestRate),
        );
    }
}
